export default "__VITE_ASSET__XL7o82gD__"